import { CLASS_NAMES } from '../../utils/constants'
import Explosion from './Explosion'
import Fallable from './Fallable'
import Player from './Player'

export default class Mushroom extends Fallable {
  constructor(id, level) {
    super({
      id,
      isRigid: false,
      isBreakable: true,
      isFlat: false,
      isPickable: true,
      isCrushable: false,
      level
    })
    this.strength = 4
  }
  overrunBy(el) {
    if(el.isClass(Player)) {
      this.alien.visible = false
      this.level.onMushroomPick(this)
      this.level.scene.events.emit('sounds:shroom_pick')
      this.level.scene.events.emit('score:mushroom_collected')
    }

    if(el.isClass(Explosion)) {
      this.alien.visible = false
      this.alien.destroy()
    }
  }
}

Mushroom.className = CLASS_NAMES.MUSHROOM
